// @ts-strict-ignore

/* eslint-disable no-underscore-dangle */
import { addFlashMessageForNextPageLoad } from 'utils/cookies';

import { HttpError } from './HttpError';
import { RichError } from './RichError';

const handleErrors = (status, url, resolve, reject, options = {}) => {
  if (status > 199 && status < 300) {
    resolve();
    return;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'skipRedirects' does not exist on type '{... Remove this comment to see the full error message
  if (options.skipRedirects) {
    reject();
    return;
  }

  let loginPath = '/login';
  let homePath = `/${CURRENT_LOCALE}/`;

  if (window.location.pathname.startsWith('/fair')) {
    homePath = '/fair';
    loginPath = '/fair/login';
  }

  if (/\/[^/]/.test(url)) {
    // don't redirect on 401/403 for algolia requests
    if (status === 401) {
      addFlashMessageForNextPageLoad('LOGIN_REQUIRED');
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
      window.location = loginPath;
      return;
    }

    if (status === 403) {
      addFlashMessageForNextPageLoad('FORBIDDEN');
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
      window.location = homePath;
      return;
    }

    if (
      (status === 408 ||
        /* Request Timeout */
        status >= 500) &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'retriesRemaining' does not exist on type... Remove this comment to see the full error message
      options.retriesRemaining
    ) {
      setTimeout(() => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'retriesRemaining' does not exist on type... Remove this comment to see the full error message
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getJsonInternal(url, resolve, reject, options.retriesRemaining - 1);
      }, 1000);
      return;
    }

    reject();
    return;
  }

  reject();
};

export const initXMLHttpRequestActiveCounter = () => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
  XMLHttpRequest._allRequests = [];
  // @ts-expect-error ts-migrate(2339) FIXME: Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
  XMLHttpRequest._completedRequests = [];
  const oldOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function open(...args) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line prefer-destructuring
    this._url = args[1];
    oldOpen.apply(this, args);
  };

  const oldSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function send(...args) {
    if (!this._url.includes('sockjs-node')) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
      XMLHttpRequest._allRequests.push(this._url);

      this.addEventListener('loadend', () => {
        setTimeout(() => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
          XMLHttpRequest._completedRequests.push(this._url);
        }, 1);
      });
    }

    oldSend.apply(this, args);
  };
};

const checkVersion = (version) => {
  if (version > window.Idealist._version) {
    window.Idealist.forceUpdate({
      oldVersion: window.Idealist._version,
      newVersion: version,
    });
  }
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line consistent-return
function parseJsonResponse(xhr, reject) {
  if (!xhr.responseText) {
    return null;
  }

  if (xhr.getResponseHeader('Content-Type').indexOf('json') < 0) {
    reject(
      new RichError('Invalid Content-Type for JSON response', {
        responseURL: xhr.responseURL,
        contentType: xhr.getResponseHeader('Content-Type'),
      })
    );
  }

  try {
    const json = JSON.parse(xhr.responseText);
    checkVersion(json._version);
    return json;
  } catch (err) {
    reject(
      new RichError('Error parsing JSON response', {
        responseURL: xhr.responseURL,
        errorMessage: err.message,
      })
    );
  }
}

export function getJson<T = unknown>(url): Promise<T> {
  return new Promise((resolve, reject) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    getJsonInternal(
      url,
      resolve,
      reject,
      5
      /* retriesRemaining */
    );
  });
}

const getJsonInternal = (url, resolve, reject, retriesRemaining) => {
  const xhr = new XMLHttpRequest();
  xhr.addEventListener('load', () => {
    handleErrors(
      xhr.status,
      url,
      () => resolve(parseJsonResponse(xhr, reject)),
      () => reject(new HttpError('GET', url, xhr)),
      {
        retriesRemaining,
      }
    );
  });
  xhr.open('GET', url, true);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.send();
};

export const postData = (url, formData) => {
  const retriesRemaining = 1;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(xhr.responseText),
        () => reject(new HttpError('GET', url, xhr)),
        {
          retriesRemaining,
        }
      );
    });
    xhr.open('POST', url, true);
    xhr.send(formData);
  });
};
export function postJson<T = unknown>(
  url,
  data = {},
  options = {}
): Promise<T> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(parseJsonResponse(xhr, reject)),
        () => reject(new HttpError('POST', url, xhr))
      );
    });
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'headers' does not exist on type '{}'.
    if (options.headers && Object.keys(options.headers).length > 0) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'headers' does not exist on type '{}'.
      Object.entries(options.headers).forEach(([k, v]) => {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        xhr.setRequestHeader(k, v);
      });
    }

    xhr.send(JSON.stringify(data));
  });
}
export function putJson<TData>(url, data) {
  return new Promise<TData>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(parseJsonResponse(xhr, reject)),
        () => reject(new HttpError('PUT', url, xhr))
      );
    });
    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  });
}
export function patchJson<TData>(url, data) {
  return new Promise<TData>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(parseJsonResponse(xhr, reject)),
        () => reject(new HttpError('PATCH', url, xhr))
      );
    });
    xhr.open('PATCH', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  });
}
export function post(url, data, options = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(xhr.responseText),
        () => reject(new HttpError('POST', url, xhr)), // don't redirect on 401/403 for algolia requests
        {
          skipRedirects: !/^\/[^/]/.test(url),
        }
      );
    });
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Accept', 'application/json');

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'contentType' does not exist on type '{}'... Remove this comment to see the full error message
    if (options.contentType !== false) {
      xhr.setRequestHeader(
        'Content-Type',
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'contentType' does not exist on type '{}'... Remove this comment to see the full error message
        options.contentType || 'application/x-www-form-urlencoded'
      );
    }

    xhr.send(data);
  });
}
export function del<TData = unknown>(url) {
  return new Promise<TData>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => {
          if (xhr.responseText) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            resolve();
          }
        },
        () => reject(new HttpError('DELETE', url, xhr))
      );
    });
    xhr.open('DELETE', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send();
  });
}
/* eslint-enable no-underscore-dangle */
